<template>
  <div>
    <el-row></el-row>
  </div>
</template>

<script>
export default {
  name: 'page__survey_history',

  data() {
    return {}
  },

  async beforeMount() {
    await this.m__get_shops()
  },

  methods: {
    async m__get_shops() {
      const response = await this.$http.get(this.API.URL_API_SRV_1 + '/shop_history/shops', {
        params: {mipeeUserId: this.$store.state.userInfo.username}
      })
      console.log(response)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tool/history.vue